import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm$listCountries, _vm$listCountries2, _vm$displayedListWine, _vm$displayedListWine2, _vm$displayedListAppe, _vm$displayedListAppe2;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "filter-bloc"
  }, [_c("div", {
    staticClass: "filter-title"
  }, [_c("h4", [_vm._v("Filter by")]), _vm.isFiltering ? _c("span", {
    staticClass: "clear-text",
    on: {
      click: _vm.clearFilters
    }
  }, [_vm._v("Clear filters")]) : _vm._e()]), _c(VDivider, {
    staticClass: "mt-4 mb-4"
  }), _c("div", {
    staticClass: "filter-bloc-filters"
  }, [_c("div", [_c(VCheckbox, {
    key: "render-stockOnly-" + _vm.boolRenderLinkedCheckbox,
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "Available products only",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.changeStockOnlyFilter();
      }
    },
    model: {
      value: _vm.filters.stockOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "stockOnly", $$v);
      },
      expression: "filters.stockOnly"
    }
  }), _c(VCheckbox, {
    key: "render-warehouseOnly-" + _vm.boolRenderLinkedCheckbox,
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "In warehouse only",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.changeWarehouseOnlyFilter();
      }
    },
    model: {
      value: _vm.filters.warehouseOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "warehouseOnly", $$v);
      },
      expression: "filters.warehouseOnly"
    }
  }), _vm.hasAnySpecialDeal ? _c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: _vm.isAdminNotConsultant(_vm.loggedUserData) ? "Special deals only" : "My special deals only",
      "hide-details": "auto"
    },
    on: {
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.specialDealsOnly,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "specialDealsOnly", $$v);
      },
      expression: "filters.specialDealsOnly"
    }
  }) : _vm._e()], 1), _vm.isAllowedToFilterLocation && _vm.filters.stockOnly ? _c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.storageLocations,
      "item-text": "name",
      "item-value": "continent_iso2",
      placeholder: "Storage Location",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.departureContinent,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "departureContinent", $$v);
      },
      expression: "filters.departureContinent"
    }
  })], 1) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.filters.stockOnly ? _c("div", [_c(VTextField, {
    attrs: {
      type: "number",
      min: "1",
      placeholder: "Minimum quantity in stock",
      clearable: ""
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.stockQuantityMin,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "stockQuantityMin", $$v);
      },
      expression: "filters.stockQuantityMin"
    }
  })], 1) : _vm._e(), _c(VDivider, {
    staticClass: "mt-4 mb-2 hidden-at-thispage-breakpoint"
  }), _c("div", [_c(VSelect, {
    attrs: {
      chips: "",
      items: _vm.listWineTypes,
      "item-text": "name",
      "item-value": "id_type",
      placeholder: "Wine type",
      multiple: "",
      clearable: ""
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.wine_type,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "wine_type", $$v);
      },
      expression: "filters.wine_type"
    }
  })], 1), _c("div", [_c(VSelect, {
    attrs: {
      chips: "",
      items: _vm.bottlings,
      "item-text": "text",
      "item-value": "value",
      placeholder: "Bottling",
      multiple: "",
      clearable: ""
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.bottling,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "bottling", $$v);
      },
      expression: "filters.bottling"
    }
  })], 1), _c("div", {
    staticClass: "flex --nowrap"
  }, [_c("div", {
    staticStyle: {
      width: "3.5rem"
    }
  }, [_c(VSelect, {
    attrs: {
      items: _vm.comparisonOperators,
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        _vm.filters.vintage && _vm.filtersChanged();
      }
    },
    model: {
      value: _vm.filters.vintageCmpOp,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "vintageCmpOp", $$v);
      },
      expression: "filters.vintageCmpOp"
    }
  })], 1), _c("div", {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Vintage",
      clearable: ""
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.vintage,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "vintage", $$v);
      },
      expression: "filters.vintage"
    }
  })], 1)]), _c("div", [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.listCountries,
      "item-text": "printable_name",
      "item-value": "id_country",
      placeholder: ((_vm$listCountries = _vm.listCountries) === null || _vm$listCountries === void 0 ? void 0 : _vm$listCountries.length) > 0 ? "Country & wine region" : "Loading...",
      disabled: ((_vm$listCountries2 = _vm.listCountries) === null || _vm$listCountries2 === void 0 ? void 0 : _vm$listCountries2.length) < 1,
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change() {
        _vm.changeCountry();
      }
    },
    model: {
      value: _vm.filters.country,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "country", $$v);
      },
      expression: "filters.country"
    }
  })], 1), _vm.displayedListRegions.length > 0 ? _c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListRegions,
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      placeholder: "Region",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.changeRegion
    },
    model: {
      value: _vm.filters.region,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "region", $$v);
      },
      expression: "filters.region"
    }
  })], 1) : _vm._e()]), _c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListWineries,
      "item-text": "name",
      "item-value": "id",
      placeholder: ((_vm$displayedListWine = _vm.displayedListWineries) === null || _vm$displayedListWine === void 0 ? void 0 : _vm$displayedListWine.length) > 0 ? "Winery" : "Loading...",
      disabled: ((_vm$displayedListWine2 = _vm.displayedListWineries) === null || _vm$displayedListWine2 === void 0 ? void 0 : _vm$displayedListWine2.length) < 1,
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.producer,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "producer", $$v);
      },
      expression: "filters.producer"
    }
  })], 1), _c("div", [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListAppellations,
      "item-text": "label",
      "item-value": "id_appellation",
      placeholder: ((_vm$displayedListAppe = _vm.displayedListAppellations) === null || _vm$displayedListAppe === void 0 ? void 0 : _vm$displayedListAppe.length) > 0 ? "Appellation" : "Loading...",
      disabled: ((_vm$displayedListAppe2 = _vm.displayedListAppellations) === null || _vm$displayedListAppe2 === void 0 ? void 0 : _vm$displayedListAppe2.length) < 1,
      "return-object": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.changeAppellation
    },
    model: {
      value: _vm.filters.appellation,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "appellation", $$v);
      },
      expression: "filters.appellation"
    }
  })], 1), _vm.displayedListDenominations.length > 0 ? _c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.displayedListDenominations,
      "item-text": "appellation",
      "item-value": "id_appellation",
      placeholder: "Denomination",
      "return-object": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.denomination,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "denomination", $$v);
      },
      expression: "filters.denomination"
    }
  })], 1) : _vm._e()]), _c("div", [_c(VSelect, {
    attrs: {
      chips: "",
      "deletable-chips": "",
      placeholder: "Privilege access",
      items: _vm.listWineRangeAccessibility,
      "item-value": "id",
      "item-text": "textForProductFilters",
      clearable: "",
      multiple: ""
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.rangeAccessibilities,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "rangeAccessibilities", $$v);
      },
      expression: "filters.rangeAccessibilities"
    }
  })], 1), _vm.isPriceRangeFiltererShown ? _c("div", {
    staticClass: "d-flex gap-5 align-center"
  }, [_c("div", {
    staticClass: "d-flex align-baseline gap-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-greater-than-equal v-icon-price-range"
  }), _c(VTextField, {
    attrs: {
      placeholder: "Min price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey,
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.priceRange.min,
      callback: function callback($$v) {
        _vm.$set(_vm.filters.priceRange, "min", $$v);
      },
      expression: "filters.priceRange.min"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-baseline gap-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-less-than-equal v-icon-price-range"
  }), _c(VTextField, {
    attrs: {
      placeholder: "Max price"
    },
    on: {
      keypress: _vm.filterDecimal2digitsKey,
      change: _vm.filtersChanged
    },
    model: {
      value: _vm.filters.priceRange.max,
      callback: function callback($$v) {
        _vm.$set(_vm.filters.priceRange, "max", $$v);
      },
      expression: "filters.priceRange.max"
    }
  })], 1)]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };